import { render } from "./PartnerHomePage.vue?vue&type=template&id=35953f98&scoped=true"
import script from "./PartnerHomePage.vue?vue&type=script&lang=js"
export * from "./PartnerHomePage.vue?vue&type=script&lang=js"

import "./PartnerHomePage.vue?vue&type=style&index=0&id=35953f98&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35953f98"]])

export default __exports__